module.exports = __webpack_public_path__ + "img/2005.4bee4011.png";